import { i18n } from "i18next";
import { config } from "../utils/config";

export const getLocalizedLinks = (i18n: i18n) => {
  if (i18n.languages.includes("de")) {
    return {
      PRIVACY_POLICY: config().env("REACT_APP_PRIVACY_POLICY_DE"),
      MY_DNA_PRODUCT_PAGE: config().env("REACT_APP_MY_DNA_PRODUCT_PAGE_DE"),
    };
  }

  return {
    PRIVACY_POLICY: config().env("REACT_APP_PRIVACY_POLICY_EN"),
    MY_DNA_PRODUCT_PAGE: config().env("REACT_APP_MY_DNA_PRODUCT_PAGE_EN"),
  };
};
